import React from "react";
import { FormHelperText } from "@mui/material";
import PhoneInput from "react-phone-number-input";
import styled from "styled-components";
import { fonts, Spacing } from "../../config";

interface InputPhoneProps {
  label?: string;
  error?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  readOnly?: boolean;
}

const FieldLabel = styled.p(({ theme }: any) => ({
  fontFamily: fonts.semibold,
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "15px",
  paddingBottom: "8px",
  margin: 0,
  color: theme.palette.text.primary,
  [theme.breakpoints.down("sm")]: {
    paddingBottom: "5px",
  },
}));

const StyledPhoneInput = styled(PhoneInput)(({ theme }: any) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#F0F0F0",
  borderRadius: "21px",
  paddingBlock: "14px",
  paddingInline: "20px",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    paddingBlock: "10px",
    paddingInline: "15px",
  },
  "& .PhoneInputCountry": {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginRight: "8px",
  },
  "& .PhoneInputCountrySelect": {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    zIndex: 1,
    border: 0,
    opacity: 0,
    cursor: "pointer",
  },
  "& .PhoneInputCountryIcon": {
    width: "24px",
    display: "flex",
  },
  "& .PhoneInputCountrySelectArrow": {
    marginLeft: "6px",
    marginRight: "6px",
    marginTop: "-3px",
    display: "block",
    width: "8px",
    height: "8px",
    borderStyle: "solid",
    borderColor: "var(--PhoneInputCountrySelectArrow-color, currentColor)",
    borderTopWidth: 0,
    borderBottomWidth: "var(--PhoneInputCountrySelectArrow-borderWidth, 1px)",
    borderLeftWidth: 0,
    borderRightWidth: "var(--PhoneInputCountrySelectArrow-borderWidth, 1px)",
    transform: "var(--PhoneInputCountrySelectArrow-transform, rotate(45deg))",
    opacity: "var(--PhoneInputCountrySelectArrow-opacity, 0.45)",
  },
  "& .PhoneInputInput": {
    fontFamily: fonts.medium,
    fontSize: "14px",
    border: "none",
    background: "transparent",
    width: "100%",
    outline: "none",
    color: "black",
    "&:focus-visible": { outline: "none" },
  },
}));

const FieldError = styled(FormHelperText)(() => ({
  color: "red",
  minHeight: Spacing(2.5),
}));

function InputPhone({
  label,
  error,
  value,
  onChange,
  onBlur,
  placeholder,
  readOnly,
}: InputPhoneProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <StyledPhoneInput
        defaultCountry="BR"
        international={false}
        numberInputProps={{ className: "focus:outline-none focus:ring-0" }}
        placeholder={placeholder}
        value={value}
        onChange={onChange as any}
        onBlur={onBlur}
        readOnly={readOnly}
      />
      <FieldError>{error ?? " "}</FieldError>
    </div>
  );
}

export default InputPhone;
